import { ConfigDialog } from '@gimlite/common/stores/dialog.store';
import { ConfigGQL } from '@gimlite/common/stores/gql.store';
import { ConfigI18N } from '@gimlite/common/stores/i18n.store';
import { ConfigMaps } from '@gimlite/common/stores/maps.store';
import { ConfigNotification } from '@gimlite/common/stores/notification.store';
import { ConfigSocket } from '@gimlite/common/stores/socket.store';
import { ConfigSSO } from '@gimlite/common/stores/sso.store';
import { ConfigWizard } from '../stores/wizard.store';
import { ConfigAnt } from '../stores/ant.store';
import { ConfigApp } from '../stores/app.store';
import { ConfigMenu } from '../stores/menu.store';
import { ConfigRoot } from '../stores/root.store';
import { ConfigTheme } from '../stores/theme.store';

export const useConfigUIV1 = () => ({
  ConfigDialog,
  ConfigGQL,
  ConfigI18N,
  ConfigMaps,
  ConfigNotification,
  ConfigSSO,
  ConfigWizard,
  ConfigAnt,
  ConfigApp,
  ConfigMenu,
  ConfigTheme,
  ConfigSocket,
  ConfigRoot,
});
